import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e7bd2d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "vh-100 d-flex" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "mt-3" }, "New Email", -1))
const _hoisted_5 = { class: "row pt-3" }
const _hoisted_6 = { class: "col" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "to" }, "To:", -1))
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "from" }, "From:", -1))
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "subject" }, "Subject:", -1))
const _hoisted_13 = { class: "row mt-4" }
const _hoisted_14 = { class: "col" }
const _hoisted_15 = { class: "custom-control custom-switch d-inline-block mt-3" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "isClient"
}, " Internal only? ", -1))
const _hoisted_17 = { class: "col-12 col-md-4" }
const _hoisted_18 = {
  key: 0,
  enctype: "multipart/form-data",
  novalidate: ""
}
const _hoisted_19 = { class: "dropbox" }
const _hoisted_20 = ["name", "disabled"]
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainNavigation = _resolveComponent("MainNavigation")!
  const _component_ckeditor = _resolveComponent("ckeditor")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_MainNavigation, { folderId: null }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _withDirectives(_createElementVNode("input", {
                class: "form-control",
                id: "to",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pendingEmail.to) = $event)),
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.pendingEmail.to]
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _withDirectives(_createElementVNode("input", {
                class: "form-control",
                id: "from",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.pendingEmail.from) = $event)),
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.pendingEmail.from]
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _withDirectives(_createElementVNode("input", {
                class: "form-control",
                id: "subject",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.pendingEmail.subject) = $event)),
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.pendingEmail.subject]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_ckeditor, {
              editor: _ctx.editor,
              modelValue: _ctx.pendingEmail.body,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.pendingEmail.body) = $event)),
              config: _ctx.editorConfig
            }, null, 8, ["editor", "modelValue", "config"]),
            _createElementVNode("div", _hoisted_15, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                class: "custom-control-input",
                id: "isClient",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.pendingEmail.isInternal) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.pendingEmail.isInternal]
              ]),
              _hoisted_16
            ]),
            _createElementVNode("button", {
              class: "btn btn-primary no-focus mt-2 float-right",
              onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.sendEmail()), ["prevent"]))
            }, " Send Email ")
          ]),
          _createElementVNode("div", _hoisted_17, [
            (_ctx.isInitial || _ctx.isSaving)
              ? (_openBlock(), _createElementBlock("form", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("input", {
                      type: "file",
                      multiple: "",
                      name: _ctx.uploadFieldName,
                      disabled: _ctx.isSaving,
                      onChange: _cache[6] || (_cache[6] = ($event: any) => {
                    _ctx.filesChange($event.target.name, $event.target.files);
                    _ctx.fileCount = $event.target.files.length;
                  }),
                      class: "input-file"
                    }, null, 40, _hoisted_20),
                    (_ctx.pendingEmail.attachments.length === 0)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_21, " Drag your file(s) here to begin or click to browse "))
                      : _createCommentVNode("", true),
                    (_ctx.pendingEmail.attachments.length > 0)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_22, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pendingEmail.attachments, (attachment) => {
                            return (_openBlock(), _createElementBlock("span", {
                              key: attachment.name
                            }, [
                              _createTextVNode(_toDisplayString(attachment.name), 1),
                              _hoisted_23,
                              _hoisted_24
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}